<template>
  <v-layout>{{ formattedDateTime }}</v-layout>
</template>

<script>
import moment from "moment-timezone";

export default {
  name: "DateTimeColumn",
  data() {
    return {
      selectedDateTime: null
    };
  },
  computed: {
    formattedDateTime() {
      if (!this.value) return "-";
      const date = new Date(this.value);
      return moment(date).format("DD.MM.YYYY HH:mm");
    }
  },
  props: ["entity_type", "entity", "column", "value"]
};
</script>

<style scoped></style>
